import React from 'react'
import { useEffect, useState } from "react";
import API from './utils/api.js';
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Table } from 'react-bootstrap';
import { formatearNumero } from './utils/FormatearNumero.js';


const Home = () => {
  const perfil = localStorage.getItem('perfil')

  const [inversion, setInversion] = useState(0)
  const [cantidadPrestamos, setCantidadPrestamos] = useState(0)
  const [gananciaBruta, setGananciaBruta] = useState(0)
  const [gananciaNeta, setGananciaNeta] = useState(0)
  const [cantVentas, setCantVentas] = useState(0)
  const [importeVentas, setImporteVentas] = useState(0)
  const [importeTotal, setImporteTotal] = useState(0)
  const [gananciaventa, setGananciaVenta] = useState(0)
  const [detallesPrestamos, setDetallesPrestamos] = useState([])
  
  const [detallesVentas, setDetallesVentas] = useState([])

  var url = API.urlAPI
  const urlPrestamosDiarios = url + "prestamos/PrestamosDiarios"
  const urlVentasDiarias = url + "ventas/VentasDiarias"
  const urlPrestamosDiariosDetalle = url + "prestamos/PrestamosDiariosDetalles"
  const urlVentasDiariasDetalle = url + "ventas/VentasDiariasDetalle"


const fetchTablaPrestamos = async () => {
  let res = await fetch(urlPrestamosDiariosDetalle)
    let data = await res.json()
    setDetallesPrestamos(data)
}

const fetchTablaVentas = async () => {
  let res = await fetch(urlVentasDiariasDetalle)
    let data = await res.json()
    setDetallesVentas(data)
}

console.log("DetalleVentas:", detallesVentas)




  const fetchDataDash = async () => {
    let res = await fetch(urlPrestamosDiarios)
    let data = await res.json()
    setInversion(data.map((item) => { return item.ImporteCredito }))
    setCantidadPrestamos(data.map((item) => { return item.CantPrestamos }))
    setGananciaBruta(data.map((item) => { return item.ImporteTotal }))
    setGananciaNeta(data.map((item) => { return item.GananciaNeta }))
  }


  const fetchVentasData = async () => {
    let res = await fetch(urlVentasDiarias)
    let data = await res.json()
    setCantVentas(data.map((item) => { return item.CantVentas }))
    setImporteVentas(data.map((item) => { return item.ImporteVentas }))
    setImporteTotal(data.map((item) => { return item.ImporteTotal }))
    setGananciaVenta(data.map((item) => {return item.GananciaNeta}))
  }


  useEffect(() => {
    fetchDataDash()
    fetchTablaPrestamos()
    fetchTablaVentas()
    fetchVentasData()
  }, [])



  return (
    <>
    <br></br>
    {perfil !== "user" && (
        <Row>
          <Col>
            <Card>
              <Card.Header style={{ background: "#005187", color: "white" }}><h5>Prestamos de la semana</h5></Card.Header>
              <Card.Body>
                <div className="row">

                  <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-primary shadow h-100 py-2">
                      <div className="card-body">
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                              Prestamos</div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">{Number(cantidadPrestamos)}</div>
                          </div>
                          <div className="col-auto">
                            <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                      <div className="card-body">
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                              Inversión</div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(inversion))}</div>
                          </div>
                          <div className="col-auto">
                            <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                      <div className="card-body">
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                              G.Bruta</div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaBruta))}</div>
                          </div>
                          <div className="col-auto">
                            <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                      <div className="card-body">
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                              G.Neta</div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaNeta))}</div>
                          </div>
                          <div className="col-auto">
                            <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col>
          <Card>
              <Card.Header style={{ background: "#005187", color: "white" }}><h5>Ventas de la semana</h5></Card.Header>
              <Card.Body>
            <div className="row" >
            <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-primary shadow h-100 py-2">
                      <div className="card-body">
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                          Ventas</div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">{Number(cantVentas)}</div>
                      </div>
                      <div className="col-auto">
                        <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 mb-4">
                <div className="card border-left-success shadow h-100 py-2">
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                          Importe</div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(importeVentas))}</div>
                      </div>
                      <div className="col-auto">
                        <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 mb-4">
                <div className="card border-left-success shadow h-100 py-2">
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                          Total</div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(importeTotal))}</div>
                      </div>
                      <div className="col-auto">
                        <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 mb-4">
                <div className="card border-left-success shadow h-100 py-2">
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                          Ganancia</div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(gananciaventa))}</div>
                      </div>
                      <div className="col-auto">
                        <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Card.Body>
            </Card>
          </Col>
        </Row>


)}
<br></br>
<Row>
  <Col>
<Card>
              <Card.Header style={{ background: "#005187", color: "white" }}><h5>Detalle Créditos Semanal</h5></Card.Header>
              <Card.Body>

              <Table responsive striped size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>ID Credito</th>
                                                            <th>Cliente</th>
                                                            <th>Modalidad</th>
                                                            <th>Cuotas</th>
                                                            <th>Importe Credito</th>
                                                            <th>Importe Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            (detallesPrestamos.length < 1) ? (
                                                                <tr>
                                                                    <td colSpan="7">Sin Detalles</td>
                                                                </tr>
                                                            ) :
                                                                (
                                                                  detallesPrestamos.map((item) => (
                                                                        <tr key={item.IdPrestamo}>
                                                                            
                                                                            <td>{item.IdPrestamo}</td>
                                                                            <td>{item.Cliente}</td>
                                                                            <td>{item.Modalidad}</td>
                                                                            <td>{item.CantCuotas}</td>
                                                                            <td>{item.ImporteCredito}</td>
                                                                            <td>{item.ImporteTotal}</td>
                                                                        </tr>
                                                                    ))
                                                                )


                                                        }
                                                    </tbody>
                                                </Table>
                                                </Card.Body>
            </Card>
</Col>
            <Col>
            <Card>
              <Card.Header style={{ background: "#005187", color: "white" }}><h5>Detalle Ventas Semanal</h5></Card.Header>
              <Card.Body>

              <Table responsive striped size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>ID Venta</th>
                                                            <th>Cliente</th>
                                                            <th>Modalidad</th>
                                                            <th>Cuotas</th>
                                                            <th>Importe Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            (detallesVentas.length < 1) ? (
                                                                <tr>
                                                                    <td colSpan="6">Sin Detalles</td>
                                                                </tr>
                                                            ) :
                                                                (
                                                                  detallesVentas.map((item) => (
                                                                        <tr key={item.IdVenta}>
                                                                            
                                                                            <td>{item.IdVenta}</td>
                                                                            <td>{item.Cliente}</td>
                                                                            <td>{item.Modalidad}</td>
                                                                            <td>{item.CantCuotas}</td>
                                                                            <td>{item.ImporteTotal}</td>
                                                                        </tr>
                                                                    ))
                                                                )


                                                        }
                                                    </tbody>
                                                </Table>
                                                </Card.Body>
            </Card>
            </Col>
            </Row>
    </>
  )
}

export default Home